<template>
  <div id="settingDialogMut">
    <el-dialog
      title="投放属性设置"
      @close="OnClose"
      @open="initData"
      custom-class='innerPageDialog'
      :show-close="false"
      top="0"
      :modal='false'
      width="100%"
      :visible.sync="visible"
    >
      <div class="opreationBox opreationOtherName" v-loading="loading">
        <el-form
          :model="settingForm"
          :rules="rules"
          ref="settingForm"
        >
          <el-form-item
            label="已发红包数"
            label-width="120px"
          >
            <span>{{settingForm.amountOfSend}}</span>
          </el-form-item>
          <el-form-item
            prop="amount"
            label="总数"
            label-width="120px"
            :rules="[
            { required: true, message: '总数不能为空'},
            { validator: checkIsPositiveInteger, trigger: 'blur' }]"
          >
            <el-input
              v-model="settingForm.amount"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="price"
            label="单个红包金额"
            label-width="120px"
            :rules="[
            { required: true, message: '单个红包金额不能为空'},
            { validator: checkIsPositive, trigger: 'blur' }]"
          >
            
            <el-tooltip
              :disabled="dataObj?(dataObj.price>0?true:false):false"
              content="【红包金额一旦设定则不可修改】"
              placement="bottom"
              effect="dark"
            >
              <el-input
                :disabled="dataObj?(dataObj.price>0?true:false):false"
                v-model="settingForm.price"
                autocomplete="off"
              ></el-input>
            </el-tooltip>
            <!-- <el-input
              v-model="settingForm.price"
              autocomplete="off"
            ></el-input> -->
          </el-form-item>
          
          <el-form-item
            label="投放截止时间"
            label-width="120px"
          >
            <el-date-picker
              v-model="settingForm.dateOfStopLaunch"
              clearable
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择投放截止时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="投放置顶时间"
            label-width="120px"
          >
            <el-date-picker
              v-model="settingForm.topDeadLine"
              clearable
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择投放置顶时间"
              :pickerOptions="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="设置问卷类型"
            label-width="120px"
          >
            <!-- <el-switch v-model="settingForm.isBaseQuestionnaire">
            </el-switch> -->
            <el-radio-group v-model="settingForm.questionnaireType">
              <el-radio :label="0">基础问卷</el-radio>
              <el-radio :label="1">项目问卷</el-radio>
              <el-radio :label="2">互助问卷</el-radio>
            </el-radio-group>
            <!-- <el-checkbox v-model="settingForm.isBaseQuestionnaire"></el-checkbox> -->
          </el-form-item>
          <el-form-item
            label="设置投放标签"
            label-width="120px"
          >
            <!--<el-cascader
              :options="optionsList"
              :props="props"
              v-model="checkList"
              @change="changelist"
              clearable
            ></el-cascader>-->
            <div style="max-height: 450px;overflow-y: auto;">
              <el-tree
                ref="tagTree"
                node-key="id"
                show-checkbox
                :data="treeData"
                default-expand-all
                check-on-click-node
                :default-checked-keys="defaultCheckKeys"
                :props="{ children: 'childrens', label: 'name' }"
              >
              </el-tree>
            </div>
          </el-form-item>
        </el-form>
        <div
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="OnClose">取 消</el-button>
          <el-button
            type="primary"
            @click="settingOk"
          >确 定
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {settingApi, getTags, getTagList} from 'api/request'
  import {SetTableH} from '../../../utils/utils'

  export default {
    props: {
      show: {
        type: Boolean,
        default: function () {
          return false
        },
      },
      dataObj: {
        type: Object,
        default: function () {
          return null
        },
      },
    },
    data() {
      return {
        loading: false,
        visible: this.show,
        settingForm: {
          amountOfSend: 0,
          amount: 0,
          price: 0,
          dateOfStopLaunch: null,
          topDeadLine: null,
          questionnaireType: 2,
        },
        rules: {},
        props: {
          multiple: true,
          children: 'tags',
          value: 'id',
          label: 'tagName',
        },
        provinceObj: null,
        cityList: [],
        checkList: [],
        optionsList: [],
        launchTagSetting: [],
        originalData: null,
        treeData: [],
        toLineTreeData: [],
        defaultCheckKeys: [],
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;//如果没有后面的-8.64e7就是不可以选择今天的
          }
        },
      }
    },
    watch: {
      show: {
        immediate: true,
        handler(show) {
          this.visible = this.show
        },
      },
    },
    components: {},
    methods: {
      settingOk() {
        let tagsChecked = []
        let tagIds = this.getCheckedNodes();
        tagIds.forEach(v => {
          this.toLineTreeData.forEach(cV => {
            if (((v === (cV.id + '')) && !cV.childrens) || (v === (cV.id + '')) && cV.childrens.length === 0) {
              tagsChecked.push(v)
            }
          })
        })
        this.$refs['settingForm'].validate((valid) => {
          if (valid) {
            let parmas = {
              id: this.dataObj.id,
              settingViewModel: {
                amount: this.settingForm.amount,
                price: this.settingForm.price,
                dateOfStopLaunch: this.settingForm.dateOfStopLaunch,
                topDeadLine: this.settingForm.topDeadLine,
                questionnaireType: this.settingForm.questionnaireType,
                isSendAll: this.launchTagSetting.length ? false : true,
                launchTagSetting: this.launchTagSetting,
                tagsChecked: JSON.stringify(tagsChecked)
                // tagsChecked:this.checkList?JSON.stringify(this.checkList):''
              },
            }
            settingApi(parmas).then((res) => {
              if (res) {
                this.OnClose()
                this.$parent.getQuesList()
                this.$message({
                  message: '设置成功',
                  type: 'success',
                })
              }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      initTagData(data) {
        let provinceObj = null
        let cityList = []
        data.forEach((item, index) => {
          item.tagName = item.questionTitle
          item.id = item.id
          data[index] = item
          if (item.sort === 1) {
            provinceObj = item
            provinceObj.tagName = '居住省市'
          } else if (item.sort === 2) {
            cityList = item.tags
          } else {
            this.optionsList.push(item)
          }
        })
        provinceObj.tags.forEach((item, index) => {
          cityList.forEach((citem) => {
            if (item.id === citem.parentTagId) {
              if (!provinceObj.tags[index].tags) {
                provinceObj.tags[index].tags = []
              }
              provinceObj.tags[index].tags.push(citem)
            }
          })
        })
        this.optionsList.splice(0, 0, provinceObj)
      },
      OnClose() {
        this.$emit('update:show', false)
      },
      initData() {
        this.$nextTick(async () => {
          this.loading = true
          const data = await getTagList({pageIndex: 1, pageSize: 99999})
          this.treeData = Array.isArray(data) ? data : []
          let toLineTreeData = this.treeData.length > 0 ? this.common.toLine(this.treeData, 'childrens') : []
          this.toLineTreeData = toLineTreeData
          let defaultCheckKeys = []
          let tagsChecked = this.dataObj.tagsChecked ? JSON.parse(this.dataObj.tagsChecked) : []
          if (toLineTreeData.length > 0 && tagsChecked.length > 0) {
            tagsChecked.forEach(v => {
              toLineTreeData.forEach(cV => {
                if (((v === (cV.id + '')) && !cV.childrens) || (v === (cV.id + '')) && cV.childrens.length === 0) {
                  defaultCheckKeys.push(v)
                }
              })
            })
          }
          this.settingForm = {
            amountOfSend: this.dataObj.amountOfSend,
            amount: this.dataObj.amount,
            price: this.dataObj.price,
            dateOfStopLaunch: this.dataObj.dateOfStopLaunch,
            topDeadLine: this.dataObj.topDeadLine || null,
            questionnaireType: this.dataObj.questionnaireType,
          }
          // this.checkList = this.dataObj.tagsChecked?JSON.parse(this.dataObj.tagsChecked):[]
          this.defaultCheckKeys = defaultCheckKeys
          this.loading = false
        })
      },
      //验证正整数+0
      checkIsPositiveInteger(rule, value, callback) {
        var reg = /^(0|[1-9][0-9]*)$/
        if (reg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入大于等于0的正整数'))
        }
      },
      //验证大于0的数字
      checkIsPositive(rule, value, callback) {
        var reg = /^(0|[1-9]\d*)(\s|$|\.\d{1,2}\b)/
        if (reg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入大于等于0的数字,且只能保留两位小数'))
        }
      },
      changelist(val) {
        this.launchTagSetting = []
        let checkObjList = [] // 选中选项的详细对象列表
        if (this.checkList.length) {
          this.checkList.forEach(item => {
            let obj = this.getCheckObj(item[item.length - 1])
            checkObjList.push({
              tagQId: obj.tagQuestionId,
              id: obj.id
            })
          })
          // 初始化launchTagSetting
          this.initLaunchTagSetting(checkObjList)
          // 组装数据
          this.launchTagSetting.forEach((item, index) => {
            checkObjList.forEach(cItem => {
              if (item.tagQId == cItem.tagQId) {
                if (item.tagsIds) {
                  this.launchTagSetting[index].tagsIds += `,${cItem.id}`
                } else {
                  this.launchTagSetting[index].tagsIds = `${cItem.id}`
                }
              }
            })
          })
          console.log(this.launchTagSetting)
        }
      },
      //  初始化launchTagSetting
      initLaunchTagSetting(checkObjList) {
        for (let i = 0; i < checkObjList.length; i++) {
          let tagQId = checkObjList[i].tagQId
          if (this.launchTagSetting.length) {
            if (!this.checkRepeat(tagQId)) {
              this.launchTagSetting.push({
                tagQId: tagQId,
                tagsIds: ''
              })
            }
          } else {
            this.launchTagSetting = [{
              tagQId: tagQId,
              tagsIds: ''
            }]
          }
        }
      },
      // 检查this.launchTagSetting是否有重复tagQId
      checkRepeat(id) {
        if (this.launchTagSetting.length) {
          for (let i = 0; i < this.launchTagSetting.length; i++) {
            let itemId = this.launchTagSetting[i].tagQId
            if (id == itemId) {
              return true
            }
          }
        } else {
          return false
        }
      },
      getCheckObj(id) {
        for (let i = 0; i < this.originalData.length; i++) {
          let o = this.originalData[i].tags
          if (o.length) {
            for (let j = 0; j < o.length; j++) {
              if (id == o[j].id) {
                return o[j]
              }
            }
          }
        }
      },
      // 获取设置标签
      async getTags() {
        const data = await getTagList({pageIndex: 1, pageSize: 99999})
        this.treeData = Array.isArray(data) ? data : []
        // getTags().then(res=>{
        //   this.originalData = res
        //   this.initTagData(this.originalData)
        // })
      },
      //获取选中的菜单id  组装成数组
      getCheckedNodes() {
        var rad = '';
        //获取半父节点选择key  this.$refs.tagTree.getHalfCheckedKeys()
        var ridsa = (this.$refs.tagTree.getCheckedKeys().concat(this.$refs.tagTree.getHalfCheckedKeys())).join(',');// 获取当前的选中的数据[数组] -id, 把数组转换成字符串
        //获取半父节点选择对象  this.$refs.tagTree.getHalfCheckedNodes()
        var ridsb = this.$refs.tagTree.getCheckedNodes().concat(this.$refs.tagTree.getHalfCheckedNodes());// 获取当前的选中的数据[{节点对象}]
        ridsb.forEach(ids => {//获取选中的所有的父级id
          rad += ',' + ids.id;
        });
        rad = rad.substr(1);// 删除字符串前面的','
        var rids = rad + ',' + ridsa;
        var arr = rids.split(',');//  把字符串转换成数组
        arr = [...new Set(arr)]; // 数组去重
        if (arr[0] === '') {
          arr = [];
        }
        return arr || [];
      },
    },
    mounted() {
      SetTableH(this, '.opreationOtherName')
      this.initData()
    }
  }
</script>
<style lang='scss'>
  #settingDialogMut {
    height: 100%;
    width: 100%;
    
    .dialog-footer {
      text-align: center;
    }
    
    .el-dialog__wrapper {
      position: fixed;
      top: 60px;
      right: 0;
      bottom: 0;
      left: 210px;
      overflow: auto;
      margin: 0;
      z-index: 99 !important;
      
      .innerPageDialog {
        margin: 0;
        height: 100%;
        overflow: auto;
        
        .el-dialog__header {
          display: none;
        }
        
        .el-dialog__body {
          padding: 20px;
          height: 100%;
          box-sizing: border-box;
        }
        
        .el-cascader {
          width: 100%;
        }
      }
    }
  }
</style>
